<mat-expansion-panel [expanded]="expandedPanel">
  <slot></slot>
</mat-expansion-panel>
